module.exports = __webpack_public_path__ + "img/cooperative0_logo7.11d4ba99.jpg";